module.exports = __webpack_public_path__ + "img/pd-img33.50ddc2bd.jpg";